import React from 'react';
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles';
import {Link} from 'react-router-dom'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Icon from '@material-ui/core/Icon';
import Hidden from '@material-ui/core/Hidden';

import MenuList from '@material-ui/core/MenuList';
import Avatar from '@material-ui/core/Avatar';
import Grow from '@material-ui/core/Grow';
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import logo from '../../assets/logo-white.svg'

import {
  logoutUser,
  set_path
} from '../actions'

const mapStateToProps = state => {
  return {
    current_user: state.auth.current_user.data
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logoutUser: () => dispatch( logoutUser() ),
    setPath: path => dispatch( set_path(path))
  }
}

const styles = {
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  avatar: {
    margin: 10,
    color: 'black',
    backgroundColor: '#fff',
  },
};

class ConnectedApplicationBar extends React.Component {
  state = {
    anchorEl: null,
    open: false
  };

  handleChange = event => {
    this.setState({ auth: event.target.checked });
  };

  handleMenu = event => {
    if (this.state.open) {
      this.setState({
        anchorEl: null,
        open: false
      })
    } else {
      this.setState({
        anchorEl: event.currentTarget,
        open: true
      })
    }
  };

  handleClose = () => {
    this.setState({ anchorEl: null, open: false });
  };

  render() {
    const { classes, current_user, logoutUser } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    const {name, surname} = current_user

    return (
        <AppBar position="fixed" className={this.props.className}>
          <Toolbar>
            <Hidden mdUp>
              <IconButton aria-label="open mobile menu" style={{color: 'white', padding: '0', marginRight: '16px'}} onClick={this.props.mobileMenuHandler}>
              <Icon>{this.props.mobileMenuIcon ? 'close' : 'menu'}</Icon>
              </IconButton>
            </Hidden>

            <Typography color="inherit" className={classes.grow}>
              <Link to="/" onClick={e=> this.props.setPath("/")} style={{outline: 'none'}}>
                <img alt="instalevel log" src={logo} width={124} height={24}/>
              </Link>
            </Typography>
            <div>
              <Hidden mdDown>
                <span className="body2 c-white087">
                  Welcome, {name} {surname}
                </span>
              </Hidden>

              <IconButton
                aria-owns={open ? 'menu-appbar' : null}
                aria-haspopup="true"
                onClick={ e=>{
                  if(!this.state.open) {
                    this.handleMenu(e)
                  } else {
                    e.preventDefault()
                  }
                }}
                color="inherit"
                className="nohover"
                TouchRippleProps={{
                  className: 'blue_ripple'
                }}
                buttonRef={node => {
                  this.anchorEl = node;
                }}
              >
                <Avatar className={classes.avatar}>
                  {`${(name || ' ')[0]}${(surname || ' ')[0]}`.trim().toUpperCase()}
                </Avatar>
                <Icon>{open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</Icon>
              </IconButton>
              <Popper open={this.state.open} anchorEl={this.anchorEl} transition disablePortal>
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    id="menu-list-grow"
                    style={{transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={e=>{
                          // e.preventDefault()
                        }} onClick={this.handleMenu}>
                        <MenuList>
                          <MenuItem className="drawer_link body2" component={Link} to="/profile/edit">My Profile</MenuItem>
                          <MenuItem className="body2" onClick={logoutUser}>Sign Out</MenuItem>
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </div>
          </Toolbar>
        </AppBar>
    );
  }
}

const ApplicationBar = connect(mapStateToProps, mapDispatchToProps)(ConnectedApplicationBar)

export default withStyles(styles)(ApplicationBar);



// WEBPACK FOOTER //
// ./src/js/components/ApplicationBar.js